import {
  CheckboxSchema,
  CheckboxWithOptionalTextSchema,
  ICheckbox,
  ICheckboxWithText,
  IScaleRating,
  OptionalScaleRatingSchema,
} from '../../../common';
import * as yup from 'yup';

export const CarePlan4Schema = yup.object({
  consciousnessState: yup.string().notRequired().nullable(),
  recognizeClosePersons: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  localOrientation: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  temporalOrientation: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  situativeOrientation: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  remember: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  controlEverydayActions: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  makeEverydayDecisions: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  understandInformations: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  recognizeRisks: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  communicateNeeds: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  understandRequest: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  eyeSight: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  eyeSightNoAssessment: CheckboxSchema.notRequired().nullable().default({}),
  hearingAbility: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  hearingAbilityNoAssessment: CheckboxSchema.notRequired().nullable().default({}),
  languageAbiltiy: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  facialExpressions: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  manageDailySchedule: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  rest: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  occupyOneself: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  planFutureActivities: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  interactWIthPersons: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  humanRelations: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  stayOutdoor: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  stayOutdoorUndesirable: CheckboxSchema.notRequired().nullable().default({}),
  challengingBehavior: CheckboxSchema.notRequired().nullable().default({}),
  positiveReaction: yup.string().notRequired().nullable(),
  negativeReaction: yup.string().notRequired().nullable(),
  goals: yup.string().notRequired().nullable(),
  communicateOffers: CheckboxSchema.notRequired().nullable().default({}),
  visitsOffersIndependent: CheckboxSchema.notRequired().nullable().default({}),
  outdoorActivities: yup.string().notRequired().nullable(),
  relativesContact: CheckboxWithOptionalTextSchema.notRequired().nullable().default({}),
  additionalMeasures: yup.string().notRequired().nullable(),
});

export interface ICarePlan4 {
  consciousnessState?: string;
  recognizeClosePersons: Partial<IScaleRating>;
  localOrientation: Partial<IScaleRating>;
  temporalOrientation: Partial<IScaleRating>;
  situativeOrientation: Partial<IScaleRating>;
  remember: Partial<IScaleRating>;
  controlEverydayActions: Partial<IScaleRating>;
  makeEverydayDecisions: Partial<IScaleRating>;
  understandInformations: Partial<IScaleRating>;
  recognizeRisks: Partial<IScaleRating>;
  communicateNeeds: Partial<IScaleRating>;
  understandRequest: Partial<IScaleRating>;
  participateConversation: Partial<IScaleRating>;
  eyeSight: Partial<IScaleRating>;
  eyeSightNoAssessment: ICheckbox;
  hearingAbility: Partial<IScaleRating>;
  hearingAbilityNoAssessment: ICheckbox;
  languageAbiltiy: Partial<IScaleRating>;
  facialExpressions: Partial<IScaleRating>;
  manageDailySchedule: Partial<IScaleRating>;
  rest: Partial<IScaleRating>;
  occupyOneself: Partial<IScaleRating>;
  planFutureActivities: Partial<IScaleRating>;
  interactWIthPersons: Partial<IScaleRating>;
  humanRelations: Partial<IScaleRating>;
  stayOutdoor: Partial<IScaleRating>;
  stayOutdoorUndesirable: ICheckbox;
  challengingBehavior: ICheckboxWithText;
  positiveReaction?: string;
  negativeReaction?: string;
  goals?: string;
  communicateOffers: ICheckbox;
  visitsOffersIndependent: ICheckbox;
  outdoorActivities?: string;
  relativesContact: ICheckboxWithText;
  additionalMeasures?: string;
}
